import ApiValues from '../url/apiurl'
import labels from '../../utils/constants/labels';
import Networking from '../../utils/api/apiaccess';
var axios = require('axios');
function getBasketDetails(UserID, BasketID) {

    return Networking.GetApi(`${ApiValues.getBasketDetails}userID=${UserID}&basketID=${BasketID}`, "").then(result => { return result })
        .catch(function (error) {
            return { "status": "F", "message": labels.messages.apierror }
        });

}
export default getBasketDetails
